import { render, staticRenderFns } from "./bathrooms.vue?vue&type=template&id=0c2a4406"
import script from "./bathrooms.vue?vue&type=script&lang=js"
export * from "./bathrooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports